import Http from "../api/http";

export default class News extends Http {
  constructor() {
    super();
  }
  /***********消息***************/
  /**
   * C端用户消息列表
   * @param {integer} rows -  rows
   * @param {integer} page -  page
   */
  news_messageListToC() {
    return super.post("news/messageListToC", ...arguments)
  }
  /**
   * 获取未读消息数
   */
  news_unReadMsgCountToC() {
    return super.post("news/unReadMsgCountToC", ...arguments)
  }

  /**
   * 设置消息已读
   * @param {array} field
   */
  news_readMsgToC() {
    return super.post("news/readMsgToC", ...arguments)
  }

}